import { render, staticRenderFns } from "./quanqiufuneng.vue?vue&type=template&id=2946c4e8&scoped=true"
import script from "./quanqiufuneng.vue?vue&type=script&lang=js"
export * from "./quanqiufuneng.vue?vue&type=script&lang=js"
import style0 from "./quanqiufuneng.vue?vue&type=style&index=0&id=2946c4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2946c4e8",
  null
  
)

export default component.exports